import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireSuperAdmin = false }) => {
  const { user, loading, isSuperAdmin } = useAuth();
  
  // Show loading spinner while checking auth status
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if super admin access is required
  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  
  // Render children if authenticated and authorized
  return children;
};

export default ProtectedRoute;